module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/map.js